import { DataBean } from "../DataBean";

export class ContributorType extends DataBean {



    public async getContributorTypeCatalog(args:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getContributorTypeCatalog_Number", [args]);
    }
     public async deleteContributorType(idContributorType:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteContributorType_Number", [idContributorType]);
    }
     public async updateContributorType(bean:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "admin.ContributorType_updateContributorType_admin.ContributorType", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "admin.ContributorType"
            }
        ]);
    }
}